var _ellipse, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess3 = function SvgSuccess3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 160 160"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 130,
    fill: "#0C0C0D",
    opacity: 0.2,
    rx: 60,
    ry: 15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 60,
    fill: "#308A67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M111.008 57.535a6 6 0 0 1 .458 8.472l-35 39.001a6 6 0 0 1-9.151-.26l-16-20a6 6 0 0 1 9.37-7.496l11.578 14.472 30.272-33.731a6 6 0 0 1 8.473-.458z"
  })));
};
export { SvgSuccess3 as ReactComponent };
export default __webpack_public_path__ + "assets/success-3.svg";